import React from 'react';
import { LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
export function TopBar() {
  return <header className="sticky top-0 z-50 border-b border-line bg-ink/95 backdrop-blur" data-id="element-329" data-mp="232nfsn0fptzi">
      <p className="bg-gold px-3 py-1.5 text-center text-[10px] font-extrabold uppercase tracking-wide text-ink sm:text-xs md:text-sm" data-id="element-330" data-mp="1y3akrezetglu">
        🇦🇷 Sistema N°1 para Entrenadores de Gimnasia Artística en Argentina
      </p>
      <div className="mx-auto hidden max-w-5xl items-center justify-center gap-7 py-2 text-xs font-medium text-zinc-400 md:flex" data-id="element-331" data-mp="2qr6dk8luyodc">
        <span className="flex items-center gap-1.5" data-id="element-332" data-mp="2lvhm6sjzsds4">
          <ZapIcon aria-hidden="true" className="h-3.5 w-3.5 text-gold" data-id="element-333" data-mp="2h1wl2rn3r3op" /> Acceso en 5 minutos
        </span>
        <span aria-hidden="true" className="text-zinc-700" data-id="element-334" data-mp="2c2k24hzcqgre">
          ·
        </span>
        <span className="flex items-center gap-1.5" data-id="element-335" data-mp="39j8wxrpvwira">
          <LockIcon aria-hidden="true" className="h-3.5 w-3.5 text-gold" data-id="element-336" data-mp="39l23l70hz2za" /> Pago seguro
        </span>
        <span aria-hidden="true" className="text-zinc-700" data-id="element-337" data-mp="34qftd765jggs">
          ·
        </span>
        <span className="flex items-center gap-1.5" data-id="element-338" data-mp="2610x3p1fqwy">
          <ShieldCheckIcon aria-hidden="true" className="h-3.5 w-3.5 text-gold" data-id="element-339" data-mp="672v3643lcs2" /> Garantía de 7 días
        </span>
      </div>
    </header>;
}